// extracted by mini-css-extract-plugin
export default {"image":"gNV2Qr4l","title":"Z5ylrbEc","content":"Qvk7M9_h"};